import styled from "styled-components";


export const FeatureStyleThreeBase = styled.div`

  padding-top: 100px;
  
  .divider {
    margin: 3rem 0;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, .1);
  }

  .col-md-7 {
    padding: 0px 100px;
  }

  @media (min-width: 1200px) {
    padding-top: 170px;
  }
`;
